// Identity-only adapter for the existing /suppliers contract. Never interpret
// legacy balance/transaction fields as a verified accounts-payable ledger.
export const emptySupplierForm = {name:'',phone:'',contactPerson:'',email:'',address:'',city:'',category:''};
export const supplierFields = [
    ['name','اسم المورد','text',true], ['phone','رقم الجوال','tel'],
    ['contactPerson','اسم المسؤول','text'], ['city','المدينة','text'],
    ['email','البريد الإلكتروني','email'], ['category','التصنيف','text'], ['address','العنوان','text'],
];
export const supplierText = value => typeof value === 'string' ? value.trim() : '';
const collator = new Intl.Collator('ar', {numeric:true,sensitivity:'base'});

export function validSupplierList(data) {
    return Array.isArray(data) && new Set(data.map(row=>row?.id)).size === data.length
        && data.every(row=>row && supplierText(row.id) && supplierText(row.name)
            && Object.keys(emptySupplierForm).every(key=>row[key]==null || typeof row[key]==='string'));
}

export function supplierRows(data) {
    if (!validSupplierList(data)) throw new Error('Invalid supplier directory');
    return data.map(row=>({
        id:row.id,
        ...Object.fromEntries(Object.keys(emptySupplierForm).map(key=>[key,supplierText(row[key])])),
        // Intentional nulls, even for an empty/new supplier: the directory
        // cannot prove the absence of invoices or payments.
        invoiceTotal:null, paymentTotal:null, offsetTotal:null, returnTotal:null,
        payable:null, overdue:null, lastActivity:null,
        financeStatus:'unavailable', financeReason:'AP_READER_NOT_CONNECTED',
    }));
}

export function selectSuppliers(rows, {query='',category='',sort='original'}={}) {
    const needle=supplierText(query).toLocaleLowerCase('ar');
    const result=rows.filter(row=>(!category||row.category===category)
        &&(!needle||['name','phone','city','email','contactPerson','category'].some(key=>row[key].toLocaleLowerCase('ar').includes(needle))));
    return sort==='name'?result.sort((a,b)=>collator.compare(a.name,b.name)):result;
}

export function supplierSearch(search, id) {
    const params=new URLSearchParams(search);
    if (id) params.set('supplierId',id); else params.delete('supplierId');
    return params.toString()?'?'+params.toString():'';
}
